import * as React from 'react';

const LogoIcon = (props) => {
    return (
        <span {...props}>
            <span className="logo-base">Veda.</span>
            <span className="logo-base logo-bold">Astrology</span>
            <span className="logo-base">.com</span>
        </span>
    );
};

export default LogoIcon;
